import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  makeStyles,
  Grid,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Tabs,
  Tab,
  Chip,
} from "@material-ui/core";
import moment from "moment";
import { Clear, Refresh } from "@material-ui/icons";
import DetailTab from "./DetailTab";
const useStyles = makeStyles((theme) => ({
  tableContainer: {
    marginTop: "36px",
    boxShadow: "none",
  },
  table: {
    backgroundColor: "#f2f8fb",
  },
  headerCell: {
    fontWeight: "bold",
    color: "#4f4f4f",
    borderBottom: "none",
  },
  bodyCell: {
    color: "#4f4f4f",
    borderBottom: "none",
  },
  // otifDisplay: {
  //   width: "100%",
  //   backgroundColor: "#4caf50", // Green background for "90+"
  //   color: "white",
  //   borderRadius: "4px",
  //   padding: "6px 0", // Top and bottom padding
  //   textAlign: "center",
  //   fontWeight: 500, // Bold font
  // },
  gridContainer: {
    padding: theme.spacing(2), // Adds margin on either side
  },
}));

const DetailView = ({ data, deliveryCompletionIndicator }) => {
  // console.log("Props Detail View", data);
  // const getEstimatedOtif = (otif) => {
  //   let backgroundColor = "#e0e0e0";

  //   switch (otif) {
  //     case "Upto 70":
  //       backgroundColor = "red";
  //     case "70 to 90":
  //       backgroundColor = "yellow";
  //     case "90+":
  //       backgroundColor = "red";
  //     default:
  //       backgroundColor = "#e0e0e0";

  //       return (
  //         <Chip
  //           label={otif}
  //           style={{
  //             backgroundColor: backgroundColor,
  //             color: "white",
  //             borderRadius: "4px",
  //           }}
  //         />
  //       );
  //   }
  // };
  const getEstimatedOtif = (otif) => {
    let backgroundColor = "#e0e0e0";

    switch (true) {
      case otif === "Upto 70":
        backgroundColor = "#ff0000";
        break;
      case otif === "70 to 90":
        backgroundColor = "#e78a00";
        break;
      case otif === "90+":
        backgroundColor = "#329429";
        break;
      default:
        backgroundColor = "#e0e0e0";
    }

    return (
      <Chip
        label={otif}
        style={{
          backgroundColor: backgroundColor,
          color: "white",
          borderRadius: "4px",
          width: "100%",
        }}
      />
    );
  };

  const classes = useStyles();

  return (
    <Grid container className={classes.gridContainer} justifyContent="center">
      <Grid item xs={12}>
        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell className={classes.headerCell}>CMO name</TableCell>
                <TableCell className={classes.headerCell}>PO - Line</TableCell>
                <TableCell className={classes.headerCell}>
                  Product code / description
                </TableCell>
                <TableCell className={classes.headerCell}>Plant ID</TableCell>
                <TableCell className={classes.headerCell}>
                  Planner name
                </TableCell>
                <TableCell className={classes.headerCell} align="right">
                  Committed qty.
                </TableCell>
                <TableCell className={classes.headerCell}>UoM</TableCell>
                <TableCell className={classes.headerCell}>
                  Committed date
                </TableCell>
                <TableCell className={classes.headerCell} align="center">
                  Estimated OTIF (%)
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell className={classes.bodyCell}>
                  {data?.vendorName}
                </TableCell>
                <TableCell className={classes.bodyCell}>
                  {data?.poAndLine}
                </TableCell>
                <TableCell className={classes.bodyCell}>
                  {data?.productCodeAndName}
                </TableCell>
                <TableCell className={classes.bodyCell}>
                  {data?.plantCode}
                </TableCell>
                {/* TODO: */}
                <TableCell className={classes.bodyCell}>NA</TableCell>
                <TableCell className={classes.bodyCell} align="right">
                  {data?.committedQuantity}
                </TableCell>
                <TableCell className={classes.bodyCell}>{data?.uom}</TableCell>
                <TableCell className={classes.bodyCell}>
                  {data?.committedDate
                    ? moment(data?.committedDate).format("DD-MMM-YYYY").toUpperCase()
                    : "NA"}
                </TableCell>
                <TableCell className={classes.bodyCell} align="center">
                  <div className={classes.otifDisplay}>
                    {/* {data.estimatedOTIFPercentage} */}
                    {deliveryCompletionIndicator
                      ? getEstimatedOtif(data?.OTIFPercentage)
                      : getEstimatedOtif(data?.estimatedOTIFPercentage)}
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      {/* Tabs */}
      <Grid item xs={12}>
        <DetailTab data={data} />
      </Grid>
    </Grid>
  );
};

export default DetailView;
